'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isCurrency(value) {
  return getCurrencyType(value) != null;
}

var CURRENCIES = [{
  symbol: '$',
  name: 'United States Dollar'
}, {
  symbol: '£',
  name: 'British Pound'
}, {
  symbol: '€',
  name: 'Euro'
}, {
  symbol: '¥',
  name: 'Chinese Yuan'
}, {
  symbol: '₽',
  name: 'Ruble'
}, {
  symbol: '₩',
  name: 'South Korean Won'
}, {
  symbol: '₹',
  name: 'Indian Rupee'
}];

function getCurrencyType(value) {
  if (typeof value !== 'string') {
    return;
  }

  var val = value.trim();
  var type = void 0;
  var chars = [val[0], val[val.length - 1]];

  if (val[0] === '-' && val.length > 1) {
    chars.push(val[1]);
  }

  for (var i = 0; i < CURRENCIES.length; i++) {
    var cur = CURRENCIES[i];

    if (chars.includes(cur.symbol)) {
      type = cur;
      break;
    }
  } // Take the value, remove the symbol, check if the remaining value is valid characters in a number, parse it as a
  // float, and check if it's NaN, if it is a number, return the symbol, acknowledging that it is a valid currency


  if (type === undefined) {
    return;
  } else {
    var match = val.replace(type.symbol, '').match(/^[\-0-9\.]*$/); // eslint-disable-line

    if (!match) {
      return;
    }

    return isNaN(Number.parseFloat(match[0])) ? undefined : type;
  }
}

function stripCurrency(value) {
  return Number.parseFloat(value.replace(/[^-+0-9\.]/g, '')); // eslint-disable-line
}

function currency(amount, symbol) {
  // See if it's negative an remember it for later
  var negative = false;

  if (amount < 0) {
    negative = true;
    amount = '' + amount;
    amount = amount.substring(1, amount.length);
    amount = Number.parseFloat(amount);
  }

  var contracted = contractNumber(amount);

  if (negative) {
    return '-(' + symbol + contracted + ')';
  } else {
    return '' + symbol + contracted;
  }
} // Given a number, return the number in its condensed form
// using the K, M, B, and T shorthands.
//   e.g. 1,000 -> 1K


function contractNumber(amount) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (amount == null) {
    return amount;
  }

  var defaults = {
    decimalPlaces: 2
  }; // Round to have max 2 decimal places

  if (amount > 1) {
    var dp = options.decimalPlaces === undefined ? defaults.decimalPlaces : options.decimalPlaces;
    var precision = Math.pow(10, dp);
    amount = Math.round(amount * precision) / precision;
  }

  if (amount < 1000) {
    return '' + amount;
  } else {
    defaults.decimalPlaces = 1;
  }

  options = Object.assign({}, defaults, options);
  var suffixes = ['K', 'M', 'B', 'T'];
  var suffix = '';

  if (amount >= 999999999999999) {
    return '> 999T';
  } // Repeatedly chop off 3 digits (and round) until we have a number less than 1,000.


  while (amount >= 1000) {
    amount /= 1000;
    amount = amount.toFixed(options.decimalPlaces); // Round

    amount = Number.parseFloat(amount, 10); // Convert back to a Number

    suffix = suffixes.shift();
  } // Since we reduced the number, get the next suffix
  // Is this a whole number? If so add a '.0' decimal. (e.g. 10B -> 10.0B)


  if (amount % 1 === 0) {
    amount = amount.toFixed(0);
    return amount + '.0' + suffix;
  } else {
    return amount + suffix;
  }
}

function expandNumber(num) {
  num = '' + num;

  if (num.match(/^\$?\d+(\.\d+)?([k]{0,2}|[m]{0,2}|[b]{0,2})$/i) === null) {
    return NaN;
  }

  if (num.charAt(0) === '$') {
    num = num.slice(1);
  }

  var lastChar = num.charAt(num.length - 1).replace(/[^a-zA-Z]/, '').toLowerCase();
  num = Number.parseFloat(num);

  if (lastChar === 'k') {
    num *= 1000;
  } else if (lastChar === 'm') {
    num *= 1000000;
  } else if (lastChar === 'b') {
    num *= 1000000000;
  }

  return Number(num.toFixed(4));
}

exports.contractNumber = contractNumber;
exports.currency = currency;
exports.CURRENCIES = CURRENCIES;
exports.expandNumber = expandNumber;
exports.getCurrencyType = getCurrencyType;
exports.isCurrency = isCurrency;
exports.stripCurrency = stripCurrency;